import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import PortalGuard from './components/auth/PortalGuard';
import ComingSoonPage from './pages/ComingSoonPage';
import Dashboard from './components/dashboard/Dashboard';
import ApiKeys from './components/apikeys/ApiKeys';
import Usage from './components/usage/Usage';
import APIReference from './components/apireference/APIReference';
import Models from './components/models/Models';
import PrivacyRules from './components/admin/PrivacyRules';
import CategoryRules from './components/admin/CategoryRules';
import Guide from './components/guide/Guide';
import PlansAndBilling from './components/plans/PlansAndBilling';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import SubscriptionCanceledPage from './pages/SubscriptionCanceledPage';
import Navbar from './components/layout/Navbar';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router basename="/portal">
        <div className="min-h-screen bg-gray-50">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/coming-soon" element={<ComingSoonPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <PortalGuard>
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/api-keys" element={<ApiKeys />} />
          <Route path="/usage" element={<Usage />} />
          <Route path="/plans" element={<PlansAndBilling />} />
          <Route path="/plans/success" element={<SubscriptionSuccessPage />} />
          <Route path="/plans/canceled" element={<SubscriptionCanceledPage />} />
          {/* Redirect old credits route to unified Plans page */}
          <Route path="/credits" element={<Navigate to="/plans" replace />} />
          <Route path="/api-reference" element={<APIReference />} />
          <Route path="/models" element={<Models />} />
          <Route path="/model-lists" element={<Navigate to="/models" replace />} />
          <Route path="/privacy-rules" element={<Navigate to="/category-rules" replace />} />
          <Route path="/category-rules" element={<CategoryRules />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </PortalGuard>
  );
}

export default App;
